module.exports = __webpack_public_path__ + "static/media/delivery-removebg-preview.769b64ad.png";